/**
 * Error thrown by the Apollo link chain for GraphQL/network failures.
 *
 * Apollo Client 4 removed the `ApolloError` wrapper class, so we throw this
 * dedicated error from the Apollo provider and check for it downstream via
 * `instanceof`. The `message` carries the (translatable) error key.
 *
 * Lives in `@data-access/api/error` (rather than `@data-access/graphql`) so that
 * both the GraphQL data-access layer and feature libraries — including
 * `feature/analytics` — can reference it without creating a circular dependency.
 */
export class GraphqlError extends Error {
  readonly params?: object;

  constructor(message: string, params?: object) {
    super(message);
    this.name = 'GraphqlError';
    this.params = params;
    Object.setPrototypeOf(this, GraphqlError.prototype);
  }
}
